// ServiceOverview/CmdEnvsCache.js
// Map<app.machine, CmdEnvs {app, machine, envs}> — one entry per vendor instance.
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'CmdEnvsCache';

class CmdEnvsCache extends CoreBase {
    _name = _name;

    _items = new Map();

    /**
     * Initial REST fetch — replaces the map.
     * @param {object[]} items
     */
    setAll = (items) => {
        this._items = new Map(items.map((i) => [this._toKey(i.app, i.machine), i]));
    };

    /**
     * SignalR push — overwrites per vendor instance.
     * @param {object[]} items
     */
    addOrUpdate = (items) => {
        if (!Array.isArray(items)) return;

        items.forEach(this._set);
    };

    /**
     * @param {string} app
     * @param {string} machine
     * @returns {object|undefined}
     */
    get = (app, machine) => this._items.get(this._toKey(app, machine));

    clear = () => {
        this._items.clear();
    };

    _set = (item) => {
        if (!item?.app) return;

        this._items.set(this._toKey(item.app, item.machine), item);
    };

    _toKey = (app, machine) => `${app}.${machine}`;
}

const cmdEnvsCache = new CmdEnvsCache();
export default cmdEnvsCache;
